export const iconFontAwesomeCampingMountain = (
	<i className="fa-solid fa-mountain"></i>
);
